import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyCs3pQ9Gi4zCAVQBZafc_G5Ju37LRAfuHk",
    authDomain: "chatroom-web-app.firebaseapp.com",
    databaseURL: "https://chatroom-web-app-default-rtdb.firebaseio.com",
    projectId: "chatroom-web-app",
    storageBucket: "chatroom-web-app.appspot.com",
    messagingSenderId: "20947261317",
    appId: "1:20947261317:web:cfa75cccef576b237cd6ec"
  };

  const app = firebase.initializeApp(config);
  export const auth = app.auth();
  export const database = app.database();
  export const storage = app.storage();